export default __webpack_public_path__ + "static/article-what-to-look-out-for-when-buying-a-car-53b996473b416fde6d8224eefc783dbc.jpg";